import { render } from "./UiPropMaskImage.vue?vue&type=template&id=37a07af0"
import script from "./UiPropMaskImage.vue?vue&type=script&lang=js"
export * from "./UiPropMaskImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__